// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__0m_RM","tooltip--disabled":"Tooltip_tooltip--disabled__D1LIw","titleWrapper":"Tooltip_titleWrapper__xkQtn","innerSpan":"Tooltip_innerSpan__91kW3"};